import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "col-12 col-sm-6 col-md-4 col-lg-3 q-pa-sm" };
const _hoisted_2 = {
    key: 0,
    class: "row justify-between items-center"
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "row items-center no-wrap" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { class: "text-h6" };
const _hoisted_7 = { class: "q-pt-sm" };
const _hoisted_8 = { class: "margin-twoString" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_mypage_badge = _resolveComponent("mypage-badge");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_card = _resolveComponent("q-card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_card, {
            class: _normalizeClass(["cursor-pointer q-hoverable overflow-hidden q-pa-none", { 'bg-yellow-2': _ctx.isParking }]),
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('click')))
        }, {
            default: _withCtx(() => [
                _createVNode(_component_q_card_section, { class: "q-pa-none" }, {
                    default: _withCtx(() => [
                        (!_ctx.isMobile)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(_component_mypage_badge, {
                                    class: "badge",
                                    kbn: _ctx.HanyoKb.NyukyoKb,
                                    id: _ctx.viewModel.model.taikyoStatus,
                                    "use-option-value2": true
                                }, null, 8, ["kbn", "id"]),
                                (_ctx.isParking)
                                    ? (_openBlock(), _createBlock(_component_q_icon, {
                                        key: 0,
                                        class: "q-pr-md q-pt-sm",
                                        size: "2.0em",
                                        name: "directions_car",
                                        color: "grey-7"
                                    }))
                                    : (_openBlock(), _createBlock(_component_q_icon, {
                                        key: 1,
                                        class: "q-pr-md q-pt-sm",
                                        size: "2.0em",
                                        name: "maps_home_work",
                                        color: "grey-7"
                                    }))
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.isMobile)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createVNode(_component_mypage_badge, {
                                    class: "badge",
                                    kbn: _ctx.HanyoKb.NyukyoKb,
                                    id: _ctx.viewModel.model.taikyoStatus,
                                    "use-option-value2": true
                                }, null, 8, ["kbn", "id"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_component_q_card_section, { class: "q-py-sm" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_4, [
                                (_ctx.isMobile)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        (_ctx.isParking)
                                            ? (_openBlock(), _createBlock(_component_q_icon, {
                                                key: 0,
                                                class: "q-pr-sm q-pb-xs",
                                                size: "1.5em",
                                                name: "directions_car",
                                                color: "grey-7"
                                            }))
                                            : (_openBlock(), _createBlock(_component_q_icon, {
                                                key: 1,
                                                class: "q-pr-sm q-pb-xs",
                                                size: "1.5em",
                                                name: "maps_home_work",
                                                color: "grey-7"
                                            }))
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.viewModel.bukkenNameWithRoom), 1)
                            ]),
                            _createElementVNode("div", null, _toDisplayString(_ctx.viewModel.adress), 1)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_q_icon, {
                                size: "1.5em",
                                name: "perm_identity",
                                color: "grey-7"
                            }),
                            _cache[1] || (_cache[1] = _createElementVNode("span", null, " ", -1)),
                            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-grey-7" }, "入居者", -1))
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.viewModel.nyukyosha), 1)
                        ])
                    ]),
                    _: 1
                })
            ]),
            _: 1
        }, 8, ["class"])
    ]));
}
